import { jsx } from 'react/jsx-runtime';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import { EGDSSkeleton } from '../skeleton/index.esm.js';
import { classNames } from '../../utils/classnames/index.esm.js';

/**
 * Returns a Block Skeleton
 *
 * @deprecated use <EGDSSkeleton type="block" />
 */
const EGDSBlockSkeleton = props => {
  const {
    animation,
    className,
    type
  } = props;
  const wrapperClassNames = classNames(className);
  const cornerRadiusValue = type && type === 'rounded' ? 'defaultValue' : 0;
  return jsx(EGDSSkeleton, {
    animation: animation,
    type: "block",
    className: wrapperClassNames,
    cornerRadius: cornerRadiusValue
  });
};
EGDSBlockSkeleton.displayName = 'EGDSBlockSkeleton';
EGDSBlockSkeleton.defaultProps = {
  type: 'square'
};
export { EGDSBlockSkeleton };